module.exports = __webpack_public_path__ + "static/img/20c.693bcd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/20c.jpg
// module id = f+n6
// module chunks = 0